import { OptionsItem } from '../../../services/common/miscUtils.types';

export enum VehicleType {
  NEW = 'NEW',
  STOCK = 'STOCK',
  USED = 'USED',
}

export enum VehicleTypesEnumManufacturer {
  BTO = 'BTO',
  STOCK = 'STOCK',
  OTHER = 'OTHER',
  USED = 'USED',
}

export enum FuelType {
  CNG = 'CNG',
  Diesel = 'Diesel',
  Electric = 'Electric',
  Hybrid = 'Hybrid',
  Hydrogen = 'Hydrogen',
  LPG = 'LPG',
  Petrol = 'Petrol',
  Undefined = 'undefined',
  Biofuel = 'Biofuel',
  CompressedAir = 'Compressed Air',
  SynthesisGas = 'Synthesis Gas',
}

export const fuelTypesList: Array<Readonly<OptionsItem<FuelType>>> = [
  { value: FuelType.CNG, label: 'Gaz Naturel Comprime' },
  { value: FuelType.Diesel, label: 'Diesel' },
  { value: FuelType.Electric, label: 'Electrique' },
  { value: FuelType.Hybrid, label: 'Hybride' },
  { value: FuelType.Hydrogen, label: 'Hydrogène' },
  { value: FuelType.LPG, label: 'GPL' },
  { value: FuelType.Petrol, label: 'Essence' },
  { value: FuelType.Undefined, label: 'Autre' },
  { value: FuelType.Biofuel, label: 'Biodiesel' },
  { value: FuelType.CompressedAir, label: 'Air Comprime' },
  { value: FuelType.SynthesisGas, label: 'Gaz de Synthese' },
];
